import React, { type FC } from 'react';
import { connect } from 'react-redux';
import { compose } from '@reduxjs/toolkit';

import type { BettingContextProps } from '../../../../../../types';
import type { ReduxState } from 'app/redux/types';

import { withinBettingContext } from 'app/contexts/betting';
import { SPORT_LINE_KIND } from 'app/lib/matchGridStakes';
import { isFFPrematchWS } from 'app/lib/site-configs/selectors';

import { MATCH_HEADER } from '../../../../../../constants';
import ExpansionButton from '../../../../../ExpansionButton';
import MatchLine from '../MatchLine';
import RegularLine from '../RegularLine';

import dictionary from './InnerHeaderHeadToHead.dictionary.json';

import styles from './InnerHeaderHeadToHead.module.scss';

// ---

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyType = any;

type StoreProps = {
  [key: string]: AnyType;
  // TODO: write types, if you have some free time please :)
};

type InnerHeaderHeadToHeadProps = {
  [key: string]: AnyType;
  // TODO: write types, if you have some free time please :)
};

const InnerHeaderHeadToHead: FC<InnerHeaderHeadToHeadProps & StoreProps> = ({
  expanded,
  matchId,
  lineName,
  lineKind,
  isMatchLine,
  hasStakeSlots,
  visibleStakeIds,
  expandClick,
}) => {
  const currentLineKind = lineKind || isMatchLine ? SPORT_LINE_KIND.main : SPORT_LINE_KIND.regular;

  const getContentByKind = () => {
    if (currentLineKind === SPORT_LINE_KIND.main) {
      return (
        <MatchLine hasStakeSlots={hasStakeSlots}
                   expanded={expanded}
                   title={MATCH_HEADER.title} />
      );
    }

    if (currentLineKind === SPORT_LINE_KIND.additional) {
      return (
        <MatchLine hasStakeSlots={hasStakeSlots}
                   expanded={expanded}
                   title={dictionary.additionalLineTitle} />
      );
    }

    if (currentLineKind === SPORT_LINE_KIND.regular) {
      return (
        <RegularLine visibleStakeIds={visibleStakeIds}
                     matchId={matchId} />
      );
    }
  };

  return (
    <>
      <div className={styles.lineDescription}>
        {lineName}
      </div>

      {getContentByKind()}

      {hasStakeSlots
        ? (
          <ExpansionButton
            className={styles.border}
            expansionState={expanded ? 2 : 0}
            onClick={expandClick} />
        )
        : <div className={styles.emptyBlock} />
      }
    </>
  );
};

const createMapStateToProps = (
  state: ReduxState,
  {
    $betting: {
      grid: {
        selectors: {
          mainLineId,
          stakeSlotsSelector,
          mainCellWidthSelector,
          visibleLineStakeIdsSelector,
        },
      },
      matchGrid,
    },
    lineId,
    matchId,
  }: BettingContextProps & InnerHeaderHeadToHeadProps,
) => (): StoreProps => {
  const isPrematchWS = isFFPrematchWS(state);
  // TODO: как только удалят isMain из InnerLineEntry, тогда matchLineId заменить на lineKind
  const mainLineIdWS = matchGrid?.selectors?.mainLineId;
  const stakeSlotsWSSelector = matchGrid?.selectors?.stakeSlotsSelector;
  const mainCellWidthWSSelector = matchGrid?.selectors?.mainCellWidthSelector;
  const visibleLineStakeIdsWSSelector = matchGrid?.selectors?.visibleLineStakeIdsSelector;

  const matchLineId = (isPrematchWS && mainLineIdWS)
    ? mainLineIdWS(state, { matchId })
    : mainLineId(state, { matchId });

  const stakeSlots = (isPrematchWS && stakeSlotsWSSelector)
    ? stakeSlotsWSSelector(state, lineId, matchId)
    : stakeSlotsSelector(state, lineId, matchId);

  const mainCellWidth = (isPrematchWS && mainCellWidthWSSelector)
    ? mainCellWidthWSSelector(state, lineId, matchId)
    : mainCellWidthSelector(state, lineId, matchId);

  const visibleStakeIds = (isPrematchWS && visibleLineStakeIdsWSSelector)
    ? visibleLineStakeIdsWSSelector(state, lineId, matchId)
    : visibleLineStakeIdsSelector(state, lineId, matchId);

  return {
    isMatchLine: matchLineId === lineId,
    hasStakeSlots: stakeSlots?.size !== 0,
    mainCellWidth: `${mainCellWidth}px`,
    visibleStakeIds,
  };
};

export default compose<FC<InnerHeaderHeadToHeadProps>>(
  withinBettingContext,
  connect(createMapStateToProps),
)(InnerHeaderHeadToHead);
